function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Mask-bottom-export");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2000,9.34c-275.4-22-550.84-5.14-824.42,50.83-74.17,15.18-143.18,32.37-206.47,50.34l-2.33.71C892.55,133,811,154.1,723,172.54,528.59,213.3,282.93,245.27,0,240.69v44.23H2000Z",
  transform: "translate(0 0)",
  fill: "#fff"
});

var SvgHeroMaskBottom = function SvgHeroMaskBottom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b39cf544-f17a-43fa-8f63-dc786224f1c9",
    "data-name": "bkgd",
    width: 2000,
    height: 284.92,
    viewBox: "0 0 2000 284.92",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeroMaskBottom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hero-mask-bottom.788d76e9.svg";
export { ForwardRef as ReactComponent };